export default defineNuxtPlugin(() => {
  return {
    provide: {
      errorCodeList: {
        400: {
          title: 'リクエストが正しくありません',
          message: 'リクエストの内容に問題があります。再度確認してください。',
          icon: '400 Bad Request'
        },
        404: {
          title: 'お探しのページが見つかりません。',
          message: '指定されたページが見つかりません。',
          icon: '404 Not Found'
        },
        500: {
          title: '問題が発生しました',
          message: '時間をおいて再度お試しください。',
          icon: '500 Internal Server Error'
        },
        403: {
          title: 'アクセスが拒否されました',
          message: 'このページにアクセスする権限がありません。',
          icon: '403 Forbidden'
        },
        408: {
          title: 'リクエストがタイムアウトしました',
          message: 'サーバーからの応答が遅れているため、リクエストがタイムアウトしました。',
          icon: '408 Request Timeout'
        },
        default: {
          title: 'エラーが発生しました',
          message: '申し訳ありませんが、再度お試しください。',
          icon: 'Error'
        }
      }
    }
  }
})
